import React, { useState, useEffect } from 'react';
import { Popover, PopoverHeader, PopoverBody, Label, Button } from 'reactstrap';
import Select from 'react-select';

const fetchMakes = async () => {
    const res = await fetch("https://vpic.nhtsa.dot.gov/api/vehicles/getallmakes?format=json");
    const data = await res.json();
    return data.Results.map(m => ({ value: m.Make_Name, label: m.Make_Name }));
};

const fetchModels = async (make) => {
    if (!make) return [];
    const res = await fetch(`https://vpic.nhtsa.dot.gov/api/vehicles/getmodelsformake/${encodeURIComponent(make)}?format=json`);
    const data = await res.json();
    return data.Results.map(m => ({ value: m.Model_Name, label: m.Model_Name }));
};

function UpdateVehicleMakeModelPopover({ open, target, vehicle, onSave, onCancel }) {
    const [makeOptions, setMakeOptions] = useState([]);
    const [modelOptions, setModelOptions] = useState([]);
    const [selectedMake, setSelectedMake] = useState(vehicle?.make || '');
    const [selectedModel, setSelectedModel] = useState(vehicle?.model || '');
    const [loadingModels, setLoadingModels] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        fetchMakes().then(setMakeOptions);
    }, []);

    useEffect(() => {
        if (selectedMake) {
            setLoadingModels(true);
            fetchModels(selectedMake).then((models) => {
                setModelOptions(models);
                setLoadingModels(false);
            });
        } else {
            setModelOptions([]);
        }
    }, [selectedMake]);

    const handleSave = () => {
        if (!selectedMake) return;
        setSaving(true);
        onSave(selectedMake, selectedModel);
        setSaving(false);
    };

    return (
        <Popover placement="right" isOpen={open} target={target} toggle={onCancel}>
            <PopoverHeader>Edit Make & Model</PopoverHeader>
            <PopoverBody>
                <Label for="make">Make</Label>
                <Select
                    inputId="make"
                    options={makeOptions}
                    value={makeOptions.find(opt => opt.value === selectedMake) || null}
                    onChange={opt => { setSelectedMake(opt ? opt.value : ''); setSelectedModel(''); }}
                    isClearable
                    isLoading={makeOptions.length === 0}
                    placeholder="Select Make"
                />
                <Label for="model" className="mt-2">Model</Label>
                <Select
                    inputId="model"
                    options={modelOptions}
                    value={modelOptions.find(opt => opt.value === selectedModel) || null}
                    onChange={opt => setSelectedModel(opt ? opt.value : '')}
                    isClearable
                    isDisabled={!selectedMake}
                    isLoading={loadingModels}
                    placeholder={selectedMake ? "Select Model" : "Select Make First"}
                />
                <div className="mt-3 d-flex justify-content-end">
                    <Button color="secondary" size="sm" onClick={onCancel} disabled={saving}>Cancel</Button>
                    <Button color="primary" size="sm" className="ml-2" onClick={handleSave} disabled={saving || !selectedMake || loadingModels}>Save</Button>
                </div>
            </PopoverBody>
        </Popover>
    );
}

export default UpdateVehicleMakeModelPopover;
